import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { AuthLinksResponse, SocialConnectionLinks, SocialConnections, VAPIResponse } from '../interfaces';

@Injectable()
export class GoogleBusinessConnectionsService {
  constructor(private readonly http: HttpClient) {}

  getAuthUrls(accountGroupId: string, nextUrl: URL): Observable<SocialConnectionLinks> {
    let newUrl = nextUrl.href;
    const urlParts = nextUrl.pathname.split('/');
    urlParts.forEach((part) => {
      if (part.startsWith('AG-')) {
        newUrl = newUrl.replace(part, accountGroupId);
      }
    });
    return this.http
      .get<AuthLinksResponse>('/ajax/v1/get-auth-urls/', {
        params: {
          accountGroupId: accountGroupId,
          nextUrl: newUrl,
        },
      })
      .pipe(
        map((response) => {
          return response.data;
        }),
      );
  }

  getSocialProfileConnections(accountGroupId: string): Observable<SocialConnections> {
    return this.http
      .get<VAPIResponse>('/ajax/v1/get-social-profile-connections/', {
        params: {
          accountGroupId: accountGroupId,
        },
      })
      .pipe(
        map((response) => response.data),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
  }
}
